__turbopack_context__.v({
  "cartDrawerContent": "n21vLG_cartDrawerContent",
  "cartProductsListWrapper": "n21vLG_cartProductsListWrapper",
  "tabletContent": "n21vLG_tabletContent",
});
